<div
    *ngIf="control?.dirty && !control?.valid && !!getErrors()?.length"
    @inOutPaneAnimation>
    <ng-container *ngFor="let error of getErrors()">
        <ion-note class="note" [color]="color">{{error}}</ion-note>
    </ng-container>
</div>
